// extracted by mini-css-extract-plugin
export default {"textWrapper":"hero_textWrapper__-KodQ","countText":"hero_countText__EG5zT","countValue":"hero_countValue__XxtId","workingWoman":"hero_workingWoman__6uqKv"};